import React from "react";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { useTranslation } from "react-i18next";
import Spinner from "./Spinner";

const hasValue = value =>
  Array.isArray(value)
    ? value.length > 0
    : value !== null && value !== undefined && String(value).trim() !== "";

const FocusPlaceholderChip = ({ label, active = false }) => {
  if (!label) return null;

  return (
    <span className={`pointer-events-none absolute -top-2 left-2 z-10 max-w-[calc(100%-1rem)] truncate rounded bg-primary px-1.5 py-0.5 text-[10px] font-semibold leading-none text-white shadow-sm transition-opacity group-focus-within:opacity-100 ${active ? "opacity-100" : "opacity-0"}`}>
      {label}
    </span>
  );
};

const SearchField = ({
  placeholder = "Search",
  value = "",
  onChange,
  iconPosition,
  className = "",
  icon = "pi pi-search",
  handleIconClick = () => { },
  handleClearClick = () => { },
  handleKeyDown = () => { },
  loading = false,
  type = "text",
  name,
  showFocusChip = false,
}) => {
  const { i18n, t } = useTranslation();
  const inputProps = {
    placeholder: t(placeholder),
    onKeyDown: (e) => {
      if (loading) return;
      if (e.key === "Enter") {
        e.preventDefault();
        handleKeyDown(e);
      }
    },
    onChange,
    pt: {
      root: { className: "!p-0 border-0 w-full h-full !bg-transparent" },
      icon: { className: "cursor-pointer" },
    },
    name,
  };

  if (value) {
    inputProps.value = value;
  } else {
    inputProps.value = "";
  }

  return (
    <div className={`group relative h-full w-full ${className}`}>
      {showFocusChip && (
        <FocusPlaceholderChip label={t(placeholder)} active={hasValue(value)} />
      )}
      <IconField
        disabled={loading}
        type={type}
        iconPosition={
          iconPosition ? iconPosition : i18n.language == "ar" ? "left" : "right"
        }
        pt={{ root: { className: "input-field !p-0 !px-2 cursor-pointer" } }}
      >
        {!loading ? (
          value ? (
            <InputIcon
              onClick={handleClearClick}
              className={"pi pi-times"}
            ></InputIcon>
          ) : (
            <InputIcon onClick={handleIconClick} className={icon}></InputIcon>
          )
        ) : (
          <InputIcon
            className={
              iconPosition == "left"
                ? "pi pi-spin pi-spinner"
                : "pi pi-spin pi-spinner"
            }
          ></InputIcon>
        )}
        <InputText {...inputProps} />
      </IconField>
    </div>
  );
};

export default SearchField;
